import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import service from "auth/FetchInterceptor";

const initialState = {
  items: [],
  loading: false,
  error: null,
  total: 0,
  page: 1,
  limit: 10,
};

export const fetchPropertyTypes = createAsyncThunk(
  "propertyType/fetchAll",
  async ({ page = 1, limit = 10 }, thunkAPI) => {
    try {
      const response = await service.get(`/biens?page=${page}&limit=${limit}`);
      console.log(response.data);
      return response.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Erreur de récupération"
      );
    }
  }
);

export const createPropertyType = createAsyncThunk(
  "propertyType/create",
  async (data, thunkAPI) => {
    try {
      const response = await service.post("/biens", data);
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Erreur de création"
      );
    }
  }
);

export const updatePropertyType = createAsyncThunk(
  "propertyType/update",
  async ({ id, data }, thunkAPI) => {
    try {
      const response = await service.put(`/biens/${id}`, data);
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Erreur de mise à jour"
      );
    }
  }
);

export const deletePropertyType = createAsyncThunk(
  "propertyType/delete",
  async (id, thunkAPI) => {
    try {
      await service.delete(`/biens/${id}`);
      return id;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Erreur de suppression"
      );
    }
  }
);

const propertyTypeSlice = createSlice({
  name: "propertyType",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // FETCH
      .addCase(fetchPropertyTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPropertyTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.items;
        state.total = action.payload.totalItems;
        state.page = action.payload.currentPage;
        state.limit = action.payload.limit;
      })
      .addCase(fetchPropertyTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // CREATE
      .addCase(createPropertyType.fulfilled, (state, action) => {})

      // UPDATE
      .addCase(updatePropertyType.fulfilled, (state, action) => {
        const index = state.items.findIndex(
          (item) => item.id === action.payload.id
        );
        if (index !== -1) {
          state.items[index] = action.payload;
        }
      })

      // DELETE
      .addCase(deletePropertyType.fulfilled, (state, action) => {
        state.items = state.items.filter((item) => item.id !== action.payload);
      });
  },
});

export default propertyTypeSlice.reducer;
